import t from "../../theme";

export const useGetProfileScreenStyles = () => {
  return {
    privacyContainer: {
      display: "flex",
      maxWidth: "80%",
      flexDirection: "column",
      margin: "auto",
      textAlign: "justify",
      background: t.glass.light,
      backdropFilter: t.blur.heavy,
      WebkitBackdropFilter: t.blur.heavy,
      borderRadius: t.radius.lg,
      padding: "40px",
      border: `1px solid ${t.glass.light}`,
      boxShadow: t.shadow.lg,
      color: t.text.primary,
      marginTop: "20px",
      marginBottom: "40px",
    },
    logo: {
      margin: "2% 0",
      textAlign: "center",
    },
  };
};
